import { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useRouteContext } from "@tanstack/react-router";

import LayoutContentArea from "@/components/layout/LayoutContentArea";
import ExtractsCard from "@/components/extracts/ExtractsCard";
import RequestAnomalyExtractsCard from "@/components/extracts/RequestExtractsCard/RequestAnomalyExtractsCard";
import RequestODSExtractsCard from "@/components/extracts/RequestExtractsCard/RequestODSExtractsCard";
import RequestCSPPIDExtractsCard from "@/components/extracts/RequestExtractsCard/RequestCSPPIDExtractsCard";

export default function ExportsPage() {
  const leaContext = useRouteContext({ from: "/$leaid" });
  const [activeTab, setActiveTab] = useState("ods");
  return (
    <LayoutContentArea headingText="Data Exports">
      <Tabs
        className="section-tabs"
        fill
        activeKey={activeTab}
        onSelect={(key) => setActiveTab(key || "")}
      >
        <Tab eventKey="ods" title="ODS Data Exports">
          {activeTab === "ods" && <RequestODSExtractsCard />}
        </Tab>
        {leaContext.hasRole("CHLDView") && (
          <Tab eventKey="CSPPID" title="CSPPID Data Export">
            {activeTab === "CSPPID" && <RequestCSPPIDExtractsCard />}
          </Tab>
        )}
        <Tab eventKey="anomaly" title="Discrepancy Data Export">
          {activeTab === "anomaly" && <RequestAnomalyExtractsCard />}
        </Tab>
      </Tabs>

      <ExtractsCard />
    </LayoutContentArea>
  );
}
